module.exports = __webpack_public_path__ + "static/img/label-05.a5ea942.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/thaipost/label-05.png
// module id = EAAR
// module chunks = 150